import styled from 'styled-components';
import { ScrollBarStyle } from '../../ScrollBars/StyledComponents';

const darkGrey = '#444';

export const Wrapper = styled.div`
  background: #ffffff;
  border-radius: 3px;
  box-shadow: #fff 0 0 1px 0;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  line-height: 1em;
  position: relative;
  margin: 0;

  &:after{
    font-size: normal;
    content: '\f0d7';
    font-family: "Font Awesome 5 Pro";
    position: absolute;
    right: 0.9em;
    top: 50%;
    font-weight: 900;
    transform: translateY(-50%);
    color: ${darkGrey}
  }
`;

export const SearchInput = styled.input`
  appearance: none;
  background: transparent;
  border-radius: 0;
  border: 1px solid #cac8c8;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 16px;
  height: 100%;
  overflow: hidden;
  padding: calc( (45px - 1em - 2px) / 2 ) 1.5em;
  position: relative;
  text-overflow: ellipsis;
  transition: border .3s ease;
  vertical-align: top;
  white-space: nowrap;
  width: 100%;
  word-wrap: break-word;
  z-index: 3;
  height: 45px;
  color: ${darkGrey};
  box-sizing: border-box;

  &:focus {
    box-shadow: none;
    outline: 0;
  }

  &::-ms-clear {
    display: none;
  }
`;

export const showResults = (props) => {
  if (props.isOpen) {
    return `
      display: block;
    `;
  }
  return '';
};

export const ScrollWrapper = styled.div`
  position: absolute;
  display: none;
  margin: 4px 0 0;
  width: 100%;
  ${props => props.isOpen && `
    padding: 2px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    z-index: 10000;
    background: #fff;
    box-sizing: border-box;
    display: block;
    z-index: 999;
    ${showResults}
  `}

  ${props => props.openDirectionUp && `
      margin-top: 0;
  `}
`;

export const StyledResults = styled.div`
  max-height: 145px;
  overflow: auto;
  padding: 0;
  box-sizing: border-box;
  ${ScrollBarStyle}
`;
